import React from "react";
import styles from "./AriaLiveRegion.module.scss";

const AriaLiveRegion = ({ message }: { message: string }) => {
  return (
    <div
      id="aria-live-region"
      className={styles.visuallyHidden}
      role="status"
      aria-live="polite"
    >
      {message}
    </div>
  );
};

export default AriaLiveRegion;
